import './SendConfirmation.css'
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../../LanguagePrefix';

function SendConfirmation() {
    const { t } = useTranslation();
    const langPrefix = useLanguagePrefix();

    return (
        <div className='padding-phone'>
            <div className="d-flex flex-column align-items-center justify-content-center send-confirmation gap-3">
                <h2>
                    {t('Thank you!')}
                </h2>
                <h4 style={{maxWidth:'700px', textAlign:'center', paddingInline:'20px', fontWeight:'400'}}>
                    {t('One of our customer service representatives will get in touch with you.')}
                </h4>
                <a href={`${langPrefix}/`} style={{textDecoration:'none'}}><button className='blue-outline-btn mt-5 d-flex gap-2'>
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 19.5L3.5 12.5M3.5 12.5L10.5 5.5M3.5 12.5H21.5" stroke="#1643E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                        {t('Back to homepage')}
                </button></a>
            </div>
        </div>
    );
}

export default SendConfirmation;